import { render, staticRenderFns } from "./EventReasonField.vue?vue&type=template&id=49fd6a08"
import script from "./EventReasonField.vue?vue&type=script&lang=js"
export * from "./EventReasonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports